angular
    .module('webcomm')
    .controller(
        'ChannelController', [
        '$scope',
        '$log',
        '$timeout',
        'pttService',
        'muteService',
        'channelModel',
        function($scope, $log, $timeout, pttService, muteService, channelModel) {
            let channelPttService = pttService.create($scope.channel.id);

            $scope.status = {
                isSelected() {
                    return $scope.selectedChannelId === $scope.channel.id;
                },
                isPTTButtonEnabled() {
                    return channelPttService.canTransmitAudio();
                },
                getPttIconName() {
                    return channelPttService.getPttIconName(this.isSelected());
                },
                isPttOn() {
                    return channelPttService.isPttOn();
                },
                isActivityMessageVisible: false
            }

            $scope.muteStatus = {
                muteIconName() {
                    var onOff = this.isMuted() ? "off" : "on";
                    return onOff + "_" + $scope.status.isSelected();
                },
                isMuted() {
                    return muteService.getMuteStatus($scope.channel.id);
                },
                toggleMute() {
                    muteService.toggleMute($scope.channel.id);
                }
            };

            $scope.pttStart = function($event) {
                // this is to stop the system from interpreting the PTT click as a channel select
                if ($event) {
                    $event.stopImmediatePropagation();
                }

                if (!channelPttService.isPttOn()) {
                    channelPttService.pttStart();
                }
            };

            $scope.pttStop = function($event) {
                // this is to stop the system from interpreting the PTT click as a channel select
                if ($event) {
                    $event.stopImmediatePropagation();
                }

                channelPttService.pttStop();
            };

            $scope.highlightSpeakingChannel = function(isHighlighted = true) {
                $scope.status.talkingHighlightClass = isHighlighted ? "talking5" : "";
            }

            $scope.$on(
                "$destroy",
                function(event) {
                    channelPttService.destroy();
                }
            );

            $scope.select = function(channelId) {
                if (!$scope.status.isSelected()) {
                    $scope.isMobileFeedVisible = true;
                    channelModel.selectChannel(channelId);
                } else { // Barf, i hate this, but best I can do for now --scott s
                    $scope.$parent.mobile.isMainMenuSelected = false;
                }
            };
        }
    ]);
